export default __webpack_public_path__ + "images/00072eabe839033b311fe54108d86905-rock_small.webp";